import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Mail } from "lucide-react";

const inputCls = "w-full h-10 border border-[#E6E4DD] rounded-sm px-3 text-sm text-forest focus:outline-none focus:border-forest";

export const SenderEmailForm = () => {
  const { user, setUser } = useAuth();
  const [email, setEmail] = useState(user?.sender_email || "");
  const [name, setName] = useState(user?.sender_name || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.patch("/users/me", { sender_email: email, sender_name: name });
      setUser({ ...user, ...data });
      toast.success(email ? `Campaign emails will go from ${email}` : "Using the default Propzel sender");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 border-t border-[#E6E4DD] pt-4" data-testid="sender-email-form">
      <div className="label-caps flex items-center gap-1.5"><Mail className="h-3 w-3" /> Campaign sender email</div>
      <input data-testid="sender-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Display name (e.g. Priya · Skyline Homes)" className={inputCls} />
      <input data-testid="sender-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@yourdomain.com" className={inputCls} />
      <div className="text-[11px] text-forest/55">Email campaigns you send go from this address. Its domain must be verified in Resend. Leave blank to use the default sender.</div>
      <button data-testid="sender-email-save" disabled={busy} onClick={save} className="h-9 px-4 rounded-sm border border-forest text-forest text-sm hover:bg-forest hover:text-white disabled:opacity-50 transition-colors duration-150">{busy ? "Saving…" : "Save sender"}</button>
    </div>
  );
};
